import { render, staticRenderFns } from "./QuizTeacherProfession.vue?vue&type=template&id=5b357f46&"
import script from "./QuizTeacherProfession.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherProfession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports